import React from 'react';
import {FormControlLabel, Radio} from '@mui/material';
import {
	ReactHookFormRadiosField,
	type ReactHookFormRadiosFieldProps,
} from '@netx/core-components/Form';
import type {ICustomFormItem, CustomFormFormValues} from '../../types';
import {
	getCustomFormItemTranslatedLabel,
	getCustomFormBaseFieldName,
} from '../../utils';

export interface ReactHookFormCustomFormItemRadiosProps<
	TValues extends CustomFormFormValues = CustomFormFormValues,
> extends Omit<
		ReactHookFormRadiosFieldProps<TValues>,
		'children' | 'label' | 'name' | 'required'
	> {
	item: ICustomFormItem;
}

export const ReactHookFormCustomFormItemRadiosPrimitive = <
	TValues extends CustomFormFormValues = CustomFormFormValues,
>({
	item,
	...props
}: ReactHookFormCustomFormItemRadiosProps<TValues>) => {
	const {label, value, required, disabled} = item;

	if (typeof value === 'string') return null;

	return (
		<ReactHookFormRadiosField
			disabled={disabled}
			name={getCustomFormBaseFieldName(item)}
			label={getCustomFormItemTranslatedLabel(label)}
			required={required}
			{...props}
		>
			{value.map((val) => (
				<FormControlLabel
					value={typeof val === 'string' ? val : val.key}
					disabled={disabled || typeof val === 'string' ? false : val.disabled}
					control={<Radio />}
					label={
						<span
							dangerouslySetInnerHTML={{
								__html:
									typeof val === 'string'
										? val
										: getCustomFormItemTranslatedLabel(val),
							}}
						/>
					}
				/>
			))}
		</ReactHookFormRadiosField>
	);
};

export const ReactHookFormCustomFormItemRadios =
	ReactHookFormCustomFormItemRadiosPrimitive;

export default ReactHookFormCustomFormItemRadios;
